<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title>Support</mat-panel-title>
  </mat-expansion-panel-header>
  @if (form.disabled) {
    <div fxLayout="row" fxLayoutAlign="space-between" fxLayoutGap="1em" class="mb-3">
      <dl fxFlex="45" class="settings-list">
        <dt>Support e-mail (ansøgningsskema)</dt>
        <dd>{{value.email}}</dd>
      </dl>
      <mat-divider [vertical]="true"></mat-divider>
    </div>
  }
  @if (form.enabled) {
    <form [formGroup]="form">
      <div fxLayout="row" fxLayoutAlign="space-between" class="mb-3">
        <div fxFlex="45" fxLayout="column">
          <label>E-mail</label>
          <mat-form-field>
            <input type="email" matInput formControlName="email">
            <mat-hint>Support e-mail, som vises i ansøgningsskemaet ved fejl.</mat-hint>
            @if (form.controls['email'].hasError('required')) {
              <mat-error>Obligatorisk.</mat-error>
            }
            @if (form.controls['email'].hasError('email')) {
              <mat-error>Ugyldige email.</mat-error>
            }
            @if (form.controls['email'].hasError('maxlength')) {
              <mat-error>Højst 100 tegn.</mat-error>
            }
          </mat-form-field>
        </div>
      </div>
    </form>
  }
  <mat-action-row>
    @if (form.disabled) {
      <button mat-flat-button (click)="doEdit()">Rediger</button>
    }
    @if (form.enabled) {
      <div>
        <button mat-stroked-button (click)="doCancel()">Fortryd</button>
        <button mat-flat-button (click)="doSave()" [disabled]="form.invalid">Gem</button>
      </div>
    }
  </mat-action-row>
</mat-expansion-panel>
